import api from './api';

const zapmailBase = '/api/integrations/zapmail';
const paymentsBase = '/api/payments';

export async function fetchZapmailEntitlements() {
  const { data } = await api.get(`${zapmailBase}/entitlements`);
  return data;
}

export async function checkDomainAvailability(domainNames, provider = 'gmail') {
  const { data } = await api.post(`${zapmailBase}/domains/availability`, {
    domain_names: domainNames,
    provider,
  });
  return data;
}

export async function createDomainOrder(fqdn, provider = 'gmail', years = 1) {
  const { data } = await api.post(`${zapmailBase}/domains/order`, {
    fqdn,
    provider,
    years,
  });
  return data;
}

export async function startDomainCheckout(orderId, successUrl, cancelUrl) {
  const { data } = await api.post(`${paymentsBase}/zapmail/domain-checkout`, {
    order_id: orderId,
    success_url: successUrl,
    cancel_url: cancelUrl,
  });
  return data;
}

export async function startMailboxCheckout(provider, quantity, successUrl, cancelUrl) {
  const { data } = await api.post(`${paymentsBase}/zapmail/mailbox-checkout`, {
    provider,
    quantity,
    success_url: successUrl,
    cancel_url: cancelUrl,
  });
  return data;
}

export async function listDomains(provider = 'gmail') {
  const { data } = await api.get(`${zapmailBase}/domains`, { params: { provider } });
  return data;
}

export async function listMailboxes(provider) {
  const params = provider ? { provider } : {};
  const { data } = await api.get(`${zapmailBase}/mailboxes`, { params });
  return data;
}

export async function syncMailboxes(provider = 'gmail') {
  const { data } = await api.post(`${zapmailBase}/mailboxes/sync`, null, {
    params: { provider },
  });
  return data;
}

export async function assignMailboxes(provider, domainZapmailId, mailboxes) {
  const { data } = await api.post(`${zapmailBase}/mailboxes/assign`, {
    provider,
    domain_zapmail_id: domainZapmailId,
    mailboxes,
  });
  return data;
}

export async function listPendingMailboxes() {
  const { data } = await api.get(`${zapmailBase}/mailboxes/pending`);
  return data;
}

export async function fetchZapmailMailboxCredentials(provider, accountEmail) {
  const { data } = await api.get(`${zapmailBase}/mailboxes/credentials`, {
    params: { provider, account_email: accountEmail },
  });
  return data;
}

export async function getOAuthAuthUrl(provider, params = {}) {
  const base =
    provider === 'outlook'
      ? '/api/integrations/microsoft/auth-url'
      : '/api/integrations/gmail/auth-url';
  const { data } = await api.get(base, { params });
  return data.auth_url;
}

export function zapmailDataPayload(raw) {
  if (!raw) return {};
  if (raw.data && typeof raw.data === 'object') return raw.data;
  return raw;
}
